import { Col, DatePicker, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import './Day.css'
import { GoDotFill } from "react-icons/go";
import images1 from '../../assets/images1.jfif'
import { CalendarOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import 'dayjs/locale/en'; // Import the locale you need
import AttachmentModal from '../../common/attachmentsModal';
import CalendarIcon from '../../assets/icons/calendar.svg'
function Day({staffData , selectedYearNumber, selectedMonthNumber}) {
  console.log('selectedYearNumber',selectedYearNumber); // Replace with your selected year
  console.log('selectedMonthNumber',selectedMonthNumber); // Replace with your selected year
  const [attendanceTrackerData, setAttendanceTrackerData] = useState({});
  const [attendanceLogData, setAttendanceLogData] = useState({});
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState( );
  // const [selectedDate, setSelectedDate] = useState(dayjs(new Date()).startOf('month'));
  // const [selectedDate, setSelectedDate] = useState(dayjs(new Date()).clone().subtract(1, 'day'));
    const [showSelectedDate, setshowSelectedDate] = useState();
    // const [showSelectedDate, setshowSelectedDate] = useState(moment(new Date()).subtract(1, 'day').format("YYYY-MM-DD"));
    console.log('dayStaff',staffData)
    const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [notes, setNotes] = useState();
  
    
    const showAttachmentModal = () => {
      setOpenAttachmentModal(true);
    }
  
    const attachmentsAndNotes = (attachments,notes) => {
      setAttachments(attachments)
      setNotes(notes)
      showAttachmentModal()
    }
    const handleOk = () => {
  
      setOpenAttachmentModal(false);
    };
    const handleCancel = () => {
      setOpenAttachmentModal(false);
    };
    const showCalendar = () => {
        setCalendarVisible(true);
      };
      useEffect(() => {
        console.log('s')
        const currentDate = dayjs(); // Get the current date

// Check if the selected month and year match the current month and year
if (selectedYearNumber === currentDate.year() && selectedMonthNumber - 1 === currentDate.month()) {
    setSelectedDate(currentDate); // Set selected date to current date
    setshowSelectedDate(currentDate.format("YYYY-MM-DD")); // Set showSelectedDate to current date
    const filterData = staffData?.staffAttendanceTracker?.filter(
      (item) => moment(item.attendanceDate).format('YYYY-MM-DD') ===  currentDate.format("YYYY-MM-DD")
      )
    console.log(' moment().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1).format("YYYY-MM-DD")', currentDate.format("YYYY-MM-DD"))
    setAttendanceTrackerData(filterData)
    const attenLogData = staffData?.staffAttendanceLog?.filter(
    (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === currentDate.format("YYYY-MM-DD")
    );
    setAttendanceLogData(attenLogData);
}
      else{  
        setSelectedDate(dayjs().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1))
        setshowSelectedDate(dayjs().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1).format("YYYY-MM-DD"))
        const filterData = staffData?.staffAttendanceTracker?.filter(
          (item) => moment(item.attendanceDate).format('YYYY-MM-DD') ===  moment().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1).format("YYYY-MM-DD")
          )
      console.log(' moment().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1).format("YYYY-MM-DD")', moment().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1).format("YYYY-MM-DD"))
      setAttendanceTrackerData(filterData)
      const attenLogData = staffData?.staffAttendanceLog?.filter(
        (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === moment().year(selectedYearNumber).month(selectedMonthNumber - 1).date(1).format("YYYY-MM-DD")
      );
      setAttendanceLogData(attenLogData);
        }
      }, [selectedMonthNumber,selectedYearNumber,staffData]);
      const disabledDate = (current) => {
        // Disable dates in other months
        return !current.isSame(selectedDate, 'month');
      };
      const hideCalendar = () => {
        setCalendarVisible(false);
      };
      const handleDateChange = (date,dateString) => {
        console.log('date',date)
        console.log('dateString',dateString)
        setshowSelectedDate(moment(date.$d).format("YYYY-MM-DD"))
      setSelectedDate(date);
      hideCalendar();
      setAttendanceTrackerData(staffData?.staffAttendanceTracker?.filter(
        (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === dateString
      ));
      console.log('filteredData',staffData?.staffAttendanceTracker?.filter(
        (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === dateString
      ))

      setAttendanceLogData(staffData?.staffAttendanceLog?.filter(
        (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === dateString
      ));
  
    };
   
    const handlePrevDay = () => {
        if (selectedDate) {
            const prevDay = selectedDate.clone().subtract(1, 'day');
            const firstDayOfMonth = selectedDate.clone().startOf('month');
        
            if (prevDay.isAfter(firstDayOfMonth) || prevDay.isSame(firstDayOfMonth, 'day')) {
              setSelectedDate(prevDay);
              setshowSelectedDate(moment(prevDay.$d).format("YYYY-MM-DD"));
        
              const filteredData = staffData?.staffAttendanceTracker?.filter(
                (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === moment(prevDay.$d).format("YYYY-MM-DD")
              );
              setAttendanceTrackerData(filteredData);
        
              const attenLogData = staffData?.staffAttendanceLog?.filter(
                (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === moment(prevDay.$d).format("YYYY-MM-DD")
              );
              setAttendanceLogData(attenLogData);
            } else {
              // If prev day is in the previous month, you may handle it as needed
              console.log("Prev day is in the previous month");
            }
          }
        }
        function formatTime(milliseconds) {
            const hours = Math.floor(milliseconds / 3600000);
            const minutes = Math.round((milliseconds % 3600000) / 60000);
          
            if (hours > 0) {
              return `${hours}:${minutes < 10 ? '0' : ''}${minutes} hr`;
            } else {
              return `${minutes} min`;
            }
          }
          function formatTimeWithAMPM(milliseconds) {
            console.log(milliseconds)
            const hours = Math.floor(milliseconds / 3600000);
            const minutes = Math.round((milliseconds % 3600000) / 60000);
          
            const formattedHours = hours % 12 || 12;
            const ampm = hours >= 12 ? 'PM' : 'AM';
          
            return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
          }
          const calculateShiftDuration = (shiftStartTime, shiftEndTime) => {
            console.log('shiftStartTime',shiftStartTime)
            console.log('shiftEndTime',shiftEndTime)
            const milliseconds_in_a_day = 24 * 60 * 60 * 1000;
            let shiftDuration;
          
            if (shiftStartTime <= shiftEndTime) {
                shiftDuration = shiftEndTime - shiftStartTime;
            } else {
                shiftDuration = milliseconds_in_a_day - shiftStartTime + shiftEndTime;
            }
          
            return shiftDuration;
          }
    const handleNextDay = () => {
        console.log('working')
        if (selectedDate) {
            const nextDay = selectedDate.clone().add(1, 'day');
            const lastDayOfMonth = selectedDate.clone().endOf('month');
        
            if (nextDay.isBefore(lastDayOfMonth) || nextDay.isSame(lastDayOfMonth, 'day')) {
              setSelectedDate(nextDay);
              setshowSelectedDate(moment(nextDay.$d).format("YYYY-MM-DD"));
        
              const filteredData = staffData?.staffAttendanceTracker?.filter(
                (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === moment(nextDay.$d).format("YYYY-MM-DD")
                );
              setAttendanceTrackerData(filteredData);
        
              const attenLogData = staffData?.staffAttendanceLog?.filter(
                (item) => moment(item.attendanceDate).format('YYYY-MM-DD') === moment(nextDay.$d).format("YYYY-MM-DD")
              );
              setAttendanceLogData(attenLogData);
            } else {
              // If next day is in the next month, you may handle it as needed
              console.log("Next day is in the next month");
            }
          }
         
      };

      const formatDate = (timestamp) => {
        const months = [
          'Jan', 'Feb', 'March', 'April',
          'May', 'June', 'July', 'Aug',
          'Sept', 'Oct', 'Nov', 'Dec'
        ];
      
        const date = new Date(timestamp);
        const day = date.getUTCDate();
        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();
        // Add a zero in front of the day if it's a single digit
        const formattedDay = day < 10 ? `0${day}` : day;
      
        const formattedDate = `${formattedDay} ${month} ${year}`;
      
        return formattedDate;
      };
    return (
        <div className='!mt-10'>
          <Col className='flex items-center !gap-2 mb-2'>
            <img src={CalendarIcon} onClick={showCalendar} className='h-[19px]'/>
          {calendarVisible && (   <DatePicker
              open
              value={selectedDate}
              onChange={ handleDateChange}
              format="YYYY-MM-DD"
              style={{ width: '110px' }}
              className='calendarInput text-center border-none p-0'
              onBlur={hideCalendar} // Adjust the width as needed
              disabledDate={disabledDate}

            />)}
                <span className='text-[17px] font-sbold leading-none ml-2'>{showSelectedDate}</span>
                <LeftOutlined  onClick={handlePrevDay} className='h-[22px] text-[16px] font-sbold flex items-center justify-center text-[#000] rounded-[5px]'/>
                <RightOutlined onClick={handleNextDay} className='h-[22px] text-[16px] font-sbold flex items-center justify-center text-[#000] rounded-[5px]'/>
          </Col>
          <Row className='flex items-start'>
                  <Col className='flex-initial'>
                      <div className='bg-[#F0F4FB] !py-5 rounded-2xl'>
                          <Row className='!items-stretch'>
                              <Col className='!px-6'>
                                  <div className='flex flex-col !mt-11'>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>in</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>out</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>shift</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>in Device</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>Out Device</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>OT/LT</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>Attachments</p>
                                  </div>
                              </Col>
                              <Col className='border-l !px-4 border-r'>
                                  <div className='flex flex-col items-center'>
                                      <p className='bg-[#4B8AEB] text-white rounded-3xl text-[13px] text-center !py-[2px] inline-flex justify-center !px-4 mb-3'>Planned</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>{attendanceTrackerData?.length > 0 ? formatTimeWithAMPM(attendanceTrackerData[0]?.shiftDetail.shiftStartTime) : '--'} : {attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.mainSiteDetail[0]?.locationName2 : '--'}</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>{attendanceTrackerData?.length > 0 ? formatTimeWithAMPM(attendanceTrackerData[0]?.shiftDetail.shiftEndTime) : '--'} : {attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.mainSiteDetail[0]?.locationName2 : '--'}</p>
                                      <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none'>{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.shiftDetail.shiftShortName : '--'} : {attendanceTrackerData?.length > 0 ? formatTime(calculateShiftDuration(attendanceTrackerData[0]?.shiftDetail.shiftStartTime, attendanceTrackerData[0]?.shiftDetail.shiftEndTime)) :'--'}</p>
                                  </div>

                              </Col>
                              <Col className='!px-6'>
                                  <div className='flex flex-col items-center'>
                                    <p className='bg-[#4B8AEB] text-white rounded-3xl text-[13px] text-center !py-[2px] inline-flex justify-center !px-4 mb-3'>Actual</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none' style={{ justifyContent: 'center', display: 'flex' }}>{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkInTime !== undefined && 
                                      formatTimeWithAMPM(attendanceTrackerData[0]?.checkInTime) !== undefined ? formatTimeWithAMPM(attendanceTrackerData[0]?.checkInTime) : '--' : '--'} : {attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.isCorrectInLocation ? attendanceTrackerData[0]?.checkInLocationDetail?.locationName2 ? attendanceTrackerData[0]?.checkInLocationDetail?.locationName2 : '??' : '--' : '--'}</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none' style={{ justifyContent: 'center', display: 'flex' }}>{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkOutTime !== undefined && 
                                      formatTimeWithAMPM(attendanceTrackerData[0]?.checkOutTime) !== undefined ? formatTimeWithAMPM(attendanceTrackerData[0]?.checkOutTime) : '--' : '--'} : {attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkOutLocation ? attendanceTrackerData[0]?.checkOutLocationDetail?.locationName2 ? attendanceTrackerData[0]?.checkOutLocationDetail?.locationName2  : '??' : '--' : '--'}</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none' style={{ justifyContent: 'center', display: 'flex' }}>{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkOutTime ? formatTime(attendanceTrackerData[0]?.totalWorkingHr) : '--' : '--'}</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none overflow-x-clip' style={{ justifyContent: 'center', display: 'flex' }}>{attendanceTrackerData?.length > 0 ?  attendanceTrackerData[0]?.checkInDevice ? attendanceTrackerData[0]?.checkinDeviceDetail?.firstName : '--' : '--'}</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none overflow-x-clip' style={{ justifyContent: 'center', display: 'flex' }} >{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkOutDevice ? attendanceTrackerData[0]?.checkOutDeviceDetail?.firstName : '--' : '--'}</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none' style={{ justifyContent: 'center', display: 'flex' }}>{attendanceTrackerData?.length > 0 ?
                                    attendanceTrackerData[0]?.isStaffOut ?
                                    attendanceTrackerData[0]?.staffOtTime > 0 ?
                                    formatTime(attendanceTrackerData[0]?.staffOtTime) :formatTime(attendanceTrackerData[0]?.staffLtTime)
                                    : '--' : '--'}</p>
                                    <p className='bg-[#CFDFF8] rounded-lg min-w-[100px] !px-3 h-[30px] inline-flex items-center text-[13px] !my-1 leading-none' onClick={() => attachmentsAndNotes(attendanceTrackerData[0]?.documents,attendanceTrackerData[0]?.notes)} style={{ justifyContent: 'center', display: 'flex' }}>{attendanceTrackerData?.length > 0 ?
                                    attendanceTrackerData[0]?.documents?.length > 0 ? `${attendanceTrackerData[0]?.documents?.length} item` : '--' : '--'}</p>
                                  </div>
                              </Col>
                          </Row>
                      </div>
                  </Col>
                  <Col className='flex-1 pl-4'>
                      <div className='border-l border-l-[#C9DCF9] pl-4'>
                          <div className='bg-[#F0F4FB] rounded-[15px] h-[70px] flex items-center !px-8'>
                              <span className='text-xs w-5'>in</span>
                              <span className='w-4 h-4 rounded-full block bg-[#4B8AEB] !ml-2'></span>
                              <div className='w-[30px] h-[30px] rounded-full overflow-hidden inline-flex justify-center !ml-4 !mr-2'>
                                <img src={attendanceTrackerData?.length > 0 && attendanceTrackerData[0]?.checkInImage ? attendanceTrackerData[0]?.checkInImage : ''} className='w-full h-full object-cover'/>
                              </div>
                              <span className='text-xs'>{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkInTime !== undefined && 
                                    formatTimeWithAMPM(attendanceTrackerData[0]?.checkInTime) !== undefined ? formatTimeWithAMPM(attendanceTrackerData[0]?.checkInTime) : '--' : '--'}, {attendanceTrackerData?.length > 0 && (attendanceTrackerData[0]?.isStaffIn || attendanceTrackerData[0]?.isStaffOut ) ? attendanceTrackerData[0]?.attendanceDate ? formatDate(attendanceTrackerData[0]?.attendanceDate) : '--' : '--'}</span>
                          </div>
                          <div className='day-seconpart-line !mx-7 border-l-[#C9DCF9] border-l-[1px] !px-8 py-2 !my-3'>
                              <p className='text-sm text-[#4B8AEB] font-sbold leading-none mb-1'>All Other Punches</p>
                              <div className='!-mx-3 flex flex-col items-start'>
                                  {attendanceLogData?.length > 0 && attendanceLogData?.map((data,index)=>(
                                  <div className='bg-[#F0F4FB] rounded-[15px] !p-3 items-center !my-[5px] inline-flex !pr-[75px]'>
                                    <div className='w-[30px] h-[30px] rounded-full overflow-hidden inline-flex justify-center !mr-2'>
                                      <img src={data?.checkInImage ? data?.checkInImage : ''} className='object-cover w-full h-full' />
                                    </div>
                                    <span className='text-xs'>{ formatTimeWithAMPM(data?.checkInTime) }, {formatDate(data?.attendanceDate)}</span>
                                    <span className='border-l border-[#D3D6DC] !mx-3'>&nbsp;</span>
                                    <span className='text-xs'>{data?.checkInCordinates?.latitude} {data?.checkInCordinates?.longitude} {data?.checkInLocationDetailLog?.locationName2 ? data?.checkInLocationDetailLog?.locationName2 : 'Unknown Locations'}</span>
                                  </div>                              
                                  ))}
                              </div>
                          </div>
                          <div className='bg-[#F0F4FB] rounded-[15px] h-[70px] flex items-center !px-8'>
                          <span className='text-xs w-5'>Out</span>
                              <span className='w-4 h-4 rounded-full block bg-[#DC3545] !ml-2'></span>
                              <div className='w-[30px] h-[30px] rounded-full overflow-hidden inline-flex justify-center !ml-4 !mr-2'>
                                <img src={attendanceTrackerData?.length > 0 && attendanceTrackerData[0]?.checkOutImage ? attendanceTrackerData[0]?.checkOutImage : ''} className='w-full h-full object-cover'/>
                              </div>
                              <span className='day-sec-time'>{attendanceTrackerData?.length > 0 ? attendanceTrackerData[0]?.checkOutTime !== undefined && 
                                    formatTimeWithAMPM(attendanceTrackerData[0]?.checkOutTime) !== undefined ? formatTimeWithAMPM(attendanceTrackerData[0]?.checkOutTime) : '--' : '--'}, {attendanceTrackerData?.length > 0 && attendanceTrackerData[0]?.isStaffOut ? attendanceTrackerData[0]?.attendanceDate ? formatDate(attendanceTrackerData[0]?.attendanceDate) : '--' : '--'}</span>
                          
                          </div>
                          <div className='day-seconpart-line !mx-7 border-l-[#C9DCF9] border-l-[1px] !px-8 py-2 !my-3'>
                              <p className='text-sm text-[#4B8AEB] font-sbold leading-none mb-1'>All Other Punches</p>
                              <div className='!-mx-3 flex flex-col items-start'>
                              {attendanceLogData?.length > 0 && attendanceTrackerData[0]?.isStaffOut && attendanceLogData?.map((data,index)=>(
                              <div className='bg-[#F0F4FB] rounded-[15px] !p-3 items-center !my-[5px] inline-flex !pr-[75px]'>
                                <div className='w-[30px] h-[30px] rounded-full overflow-hidden inline-flex justify-center !mr-2'>
                                  <img src={data?.checkOutImage ? data?.checkOutImage : ''} className='w-full h-full object-cover'/>
                                </div>
                                  <span className='text-xs'>{ formatTimeWithAMPM(data?.checkOutTime) }, {formatDate(data?.attendanceDate)}</span>
                                  <span className='border-l border-[#D3D6DC] !mx-3'>&nbsp;</span>
                                  <span className='text-xs'>{data?.checkOutCordinates?.latitude} {data?.checkOutCordinates?.longitude} {data?.checkOutLocationDetailLog?.locationName2 ? data?.checkOutLocationDetailLog?.locationName2 : 'Unknown Locations'}</span>
                              </div>
                              ))}
                              </div>
                          </div>
                      </div>
                  </Col>
          </Row>
        <AttachmentModal
        visible={openAttachmentModal}
        onOk={() => handleOk()}
        onCancel={handleCancel}
        notes={notes}
        attachments={attachments}
      />
        </div>
    )
}

export default Day